import { defineTable } from "convex/server";
import { v } from "convex/values";
import { internalControl } from "../../../lib/shared/validators";

export const validatorEmissionPoint = v.object({
	name: v.string(),
	code: v.string(),
	branchId: v.id("branches"),
	description: v.optional(v.string()),
	internalControl: internalControl,
});

export const emission_points = defineTable(validatorEmissionPoint)
	.index("code", ["code"])
	.index("branch_id_and_code", ["branchId", "code"])
	.index("company_id_and_code", ["internalControl.companyId", "code"])
	.index("by_company_id", ["internalControl.companyId"])
	.index("by_branch_id", ["branchId"])
	.index("by_state", ["internalControl.state"])
	.index("by_company_and_state", [
		"internalControl.companyId",
		"internalControl.state",
	])
	.index("by_company_and_branch", [
		"internalControl.companyId",
		"internalControl.branchId",
	])
	.index("by_branch_and_state", [
		"internalControl.branchId",
		"internalControl.state",
	])
	.index("by_created_by", ["internalControl.createdBy"])
	.index("by_updated_by", ["internalControl.updatedBy"])
	.index("by_created_at", ["internalControl.createdAt"])
	.index("by_company_and_created_at", [
		"internalControl.companyId",
		"internalControl.createdAt",
	]);
